import { gql } from "@apollo/client";

export const COLLECTIVE_QUOTE = gql`
  query collectiveQuote($data: CollectiveQuoteDataInput!) {
    collectiveQuote(data: $data) {
      vintage
      assistance
      monthlyTaxIncluded
      offers {
        rank
        level
        reinforcements
        ratedBracket
        monthlyTaxIncluded
        monthlyTaxExcluded
        lines {
          member
          rate
          monthlyTaxIncluded
          monthlyTaxExcluded
        }
      }
      summary {
        offers {
          rank
          level
          insuredCount
          primaryInsuredCount
          monthlyTaxIncluded
          monthlyAssistance
          annualBudget
        }
        monthlyTaxIncluded
      }
    }
  }
`;

export const COLLECTIVE_PLANS = gql`
  query collectivePlans($where: InsurancePlanWhereInput, $take: Int) {
    insurancePlans(where: $where, take: $take) {
      data {
        id
        name
        identifier
        product
        level
        isStandalone
        attachments {
          id
          name
          filename
          fileUrl
          contentType
          type
          createdDate
        }
        params {
          id
          rules {
            name
            value
          }
        }
      }
    }
  }
`;

export const COLLECTIVE_PLAN_COVERAGES = gql`
  query collectivePlanCoverages($where: InsurancePlanWhereInput) {
    insurancePlan(where: $where) {
      id
      insurancePlanCoverages {
        id
        coverageCategory {
          id
          label
          description
          order
        }
        coverageMappings {
          id
          coverage {
            id
            type
            subtype
            order
          }
          limits {
            id
            value
            upsells {
              id
            }
          }
        }
      }
    }
  }
`;

const collectiveQuotes = {
  COLLECTIVE_QUOTE,
  COLLECTIVE_PLANS,
  COLLECTIVE_PLAN_COVERAGES,
};

export default collectiveQuotes;
